module.exports = __webpack_public_path__ + "img/16l001-15.6b334811.png";